import { forwardRef, useState } from 'react';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { useSettings } from '@wu/widget-core';
import { meta } from '../meta';
import { DemoContent } from './components/demo/content';
import { FloatingButton } from './components/floating-button';
import { StyledFreeLink } from './components/free-link';
import { Window } from './components/window';
import { usePreviewThemeChanges } from './hooks/use-preview-theme-changes';
import { NavigationSwitcher } from './providers/navigation';
import { ColorBlindnessFilters } from './settings/color-blindness-filters';
import { ReadingLine } from './settings/reading-line';
import { ReadingMask } from './settings/reading-mask';

const ARIA_CONTROL_ID = 'accessibility-panel';

export const Widget = forwardRef<HTMLDivElement>((_, forwardingRef) => {
  const { renderThumbnailMode, ...settings } = useSettings();
  const [open, setOpen] = useState(!!renderThumbnailMode);

  const onOpenRequest = () => setOpen(true);
  const onCloseRequest = () => setOpen(false);

  usePreviewThemeChanges({ onOpenRequest, onCloseRequest });

  return (
    <>
      <Deactivation2 appAlias={meta.appAlias} {...settings}>
        <FloatingButton
          ref={forwardingRef}
          panelOpened={open}
          ariaControls={ARIA_CONTROL_ID}
          onClick={onOpenRequest}
        />
      </Deactivation2>

      <Window id={ARIA_CONTROL_ID} open={open} onCloseRequest={onCloseRequest}>
        <NavigationSwitcher onCloseRequest={onCloseRequest} />
        <StyledFreeLink />
      </Window>

      <DemoContent windowOpen={open} />

      <ReadingLine />
      <ReadingMask />
      <ColorBlindnessFilters />
    </>
  );
});
